export default "<div class=\"alert\" *ngIf=\"errorMessage\">\n\t{{errorMessage}}\n</div>";